// extracted by mini-css-extract-plugin
export default {"routineblock":"XR","container":"YR","carousel":"ZR","routine":"aS","heading":"bS","routinelist":"cS","routineitem":"eS","routineimg":"fS","routinedesc":"gS","routinename":"hS","routinetext":"iS","carouselwrap":"jS"};
    if(module.hot) {
      // 1713912566794
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  